export const ProductsGridViewIds = {
  DEFAULT: 'default',
  PRODUCTS: 'products',
  PATHNAME: '/products/list',
};

export const InventoryGridViewIds = {
  DEFAULT: 'default',
  INVENTORY: 'inventory',
  PATHNAME: '/products/inventory',
};
